





















import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import AppSelector from '@/components/AppSelector.vue'
import { ICarrierProductInfoInput } from '@/modules/CarrierProduct/interfaces/carrier-product-form'
import { lineOfBusinessCodeValues } from '@/modules/Carrier/helpers/carrier'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppFormCheckbox
  }
})
export default class CarrierProductFormInfo extends Vue {
  @Prop({ type: Object as () => ICarrierProductInfoInput }) value!: ICarrierProductInfoInput

  lineOfBusinessCodeOptions = lineOfBusinessCodeValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
